import $http from "./http";
// 人才申报审核
// 获取列表post
export function talentDeclarationList(data) {
  return $http({
    url: `/xmt/talentDeclaration/list`,
    data: data,
  });
}
// 获取人才材料审核列表
export function selectMaterialList(data) {
  return $http({
    url: `/xmt/talentMaterial/selectMaterialList`,
    data: data,
  });
}
// 获取人才材料审核暂存
export function stagingMaterial(data) {
  return $http({
    url: `/xmt/talentMaterial/stagingMaterial`,
    method: "post",
    data: data,
  });
}
// 获取人才材料审核暂存回显
export function stagingDisplay(data) {
  return $http({
    url: `/xmt/talentMaterial/stagingDisplay`,
    data: data,
  });
}
// 批量处理人才材料审核
export function batchMaterial(data) {
  return $http({
    url: `/xmt/talentMaterial/batchMaterial`,
    method: "post",
    data: data,
  });
}
// 获取列表返回修改
export function selectReturnPage(data) {
  return $http({
    url: `/xmt/talentDeclaration/selectReturnPage/${data.pageNum}/${data.pageSize}`,
    method: "post",
  });
}
// 获取详情页get
export function getAuditDetails(data) {
  return $http({
    url: `/xmt/talentDeclaration/getAuditDetails`,
    data: data,
  });
}
// 审核通过
export function pass(params, data) {
  return $http({
    url: `/xmt/talentDeclaration/pass`,
    method: "put",
    params: params,
    data: data,
  });
}
// 审核不通过
export function reject(params, data) {
  return $http({
    url: `/xmt/talentDeclaration/reject`,
    method: "put",
    params: params,
    data: data,
  });
}
// 返回修改
export function returnUpdate(params, data) {
  return $http({
    url: `/xmt/talentDeclaration/returnUpdate`,
    method: "put",
    params: params,
    data: data,
  });
}
// 暂存
export function turnDraft(params, data) {
  return $http({
    url: `/xmt/talentDeclaration/turnDraft`,
    method: "put",
    params,
    data,
  });
}
// 批量审核
export function batchPass(data) {
  return $http({
    url: `/xmt/talentDeclaration/batchPass`,
    method: "put",
    data: data,
  });
}
export function checkDuplicate(data) {
  return $http({
    url: `/xmt/talentDeclaration/checkDuplicate/${data.pageNum}/${data.pageSize}`,
    method: "post",
    data: data,
  });
}
export function changeIsParticipate(data) {
  return $http({
    url: `/xmt/overseasDeclaration/isParticipate?declarationId=${data.declarationId}&isparticipate=${data.isparticipate}`,
    method: "post",
    data: data,
  });
}
